import { render } from "./App.vue?vue&type=template&id=4e5c9dcb"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=4e5c9dcb&lang=css"

import exportComponent from "/Users/hanisaf/Projects/safadi-puzzler-directus/safadi-puzzler-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__